// components/ProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute: React.FC<{
    children: React.ReactNode;
    requiredPermission?: string;
}> = ({ children, requiredPermission }) => {
    // Check localStorage directly
    const token = localStorage.getItem('accessToken');
    const user = localStorage.getItem('user');

    const isAuthenticated = !!(token && user);

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (requiredPermission) {
        const parsedUser = user ? JSON.parse(user) : null;
        const permissions: string[] = parsedUser?.permissions || [];
        if (!permissions.includes(requiredPermission)) {
            return <Navigate to="/unauthorized" replace />;
        }
    }

    return <>{children}</>;
};

export default ProtectedRoute;
